import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';

const initialState = {
  user: null,
  token: localStorage.getItem('access') || null,
  isAuthenticated: !!localStorage.getItem('access'),
  status: 'idle',
  error: null,
};

// === ASYNC THUNKS ===
export const telegramLogin = createAsyncThunk(
  'auth/telegramLogin',
  async (initData) => {
    // Таймаут, щоб екран завантаження не висів вічно, якщо бекенд не відповідає
    const response = await api.post(
      '/auth/telegram-login/',
      { init_data: initData },
      { timeout: 10000 }
    );
    return response.data;
  }
);

// === SLICE ===
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem('access'); // ключ під "access"
    },
  },
  extraReducers: (builder) => {
    builder
      // TELEGRAM LOGIN
      .addCase(telegramLogin.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.token = action.payload.access;
        state.user = action.payload.user;
        state.isAuthenticated = true;
        localStorage.setItem('access', action.payload.access); // ключ під "access"
      })

      // ERRORS
      .addCase(telegramLogin.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;
